import React from 'react'

export const CreativeReportingIcon = React.forwardRef<SVGSVGElement>((props, ref): React.ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>
      <path d="M8 11V16" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
      <path d="M12 12V16" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
      <path d="M16 14L16 16" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
      <path
        d="M16.5745 4.8677L16.9683 3.686396C17.0511 3.437868 17.4027 3.437868 17.4855 3.686396L17.8793 4.8677C18.0692 5.43749 18.5163 5.8846 19.0861 6.07452L20.2674 6.46829C20.5159 6.55114 20.5159 6.90266 20.2674 6.9855L19.0861 7.37927C18.5163 7.5692 18.0692 8.01631 17.8793 8.5861L17.4855 9.7674C17.4027 10.01591 17.0511 10.01591 16.9683 9.7674L16.5745 8.5861C16.3846 8.01631 15.9375 7.5692 15.3677 7.37927L14.1864 6.9855C13.9379 6.90266 13.9379 6.55114 14.1864 6.46829L15.3677 6.07452C15.9375 5.8846 16.3846 5.43749 16.5745 4.8677Z"
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 4.5H10C6.68629 4.5 4 7.18629 4 10.5V14.5C4 17.8137 6.68629 20.5 10 20.5H14C17.3137 20.5 20 17.8137 20 14.5V11.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
})

export default CreativeReportingIcon
